<template>
  <div id="station-map" class="station-map" ref="stationMap">
    <map-navigator
      :defaultMapId="defaultMapId"
      :defaultRegionId="defaultRegionId"
      :defaultSystemKind="defaultSystemKind"
      :rootMapRequired="rootMapRequired"
      ref="mapNavigator"
    >
    </map-navigator>
  </div>
</template>

<script type="text/ecmascript-6">
import StationMap from './StationMap.js'
export default StationMap
</script>

<style lang="scss">
@import "StationMap.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/StationMap/StationMap.vue